var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "qr_code_scanner_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24",
    d: "M80-870v-10H90v4H84v6Zm0,30v-10h4v6h6v4Zm30,0v-4h6v-6h4v10Zm6-30v-6h-6v-4h10v10Zm-5,21h3v3h-3Zm0-6h3v3h-3Zm-3,3h3v3h-3Zm-3,3h3v3h-3Zm-3-3h3v3h-3Zm6-6h3v3h-3Zm-3,3h3v3h-3Zm-3-3h3v3h-3Zm12-16v12H102v-12ZM98-858v12H86v-12Zm0-16v12H86v-12Zm-3,25v-6H89v6Zm0-16v-6H89v6Zm16,0v-6h-6v6Z",
    transform: "translate(-80 880)",
    fill: "#22638d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qrCode.c01c7f86a0e0c660ed6b4833f94852c6.svg";
export { ForwardRef as ReactComponent };